import { zSchema, schemes, EOrderStatus } from "@zeal/common";

export const getOrdersRequestSchema = zSchema.object({
  companyID: schemes.uuid(),
  customerAccountID: schemes.uuid().optional(),
  orderID: schemes.uuid().optional(),
  status: zSchema.nativeEnum(EOrderStatus).optional(),
});

export type TGetOrdersRequestSchema = zSchema.infer<
  typeof getOrdersRequestSchema
>;

export const getOrdersResponseSchema = zSchema.array(
  zSchema.object({
    companyID: schemes.uuid(),
    customerAccountID: schemes.uuid(),
    customer_name: zSchema.string().optional(),
    createdAt: zSchema.date().optional(),
    orderID: schemes.uuid(),
    businessCardID: zSchema.string().optional(),
    approval_required: zSchema.boolean(),
    approved: zSchema.boolean(),
    contractor_payments: zSchema.array(schemes.mongoObjectId()).optional(),
    flat: zSchema.number(),
    memo: zSchema.string().optional(),
    order_total: zSchema.number(),
    payment_receipt_link: zSchema.string().nullable(),
    status: zSchema.string(),
    submitted_at: zSchema.date().optional(),
    last_four: zSchema.string().optional(),
  })
);

export type TGetOrdersResponseSchema = zSchema.infer<
  typeof getOrdersResponseSchema
>;
